// import React, { useState, useEffect } from 'react';
// import { useGetAllCommonAdminInitialDataMutation } from 'slices/get/common';
// import useService from 'views/default/useService';

// // Mock API functions - replace with your actual imports
// // const useGetAllCommonAdminInitialDataMutation = () => [
// //   async ({ ep, token }) => {
// //     // Mock implementation
// //     return { data: { data: [] } };
// //   }
// // ];

// // const useService = () => ({
// //   checkAccessTime: () => {},
// //   fetchAccessToken: () => 'mock-token'
// // });

// const CommonTableFilters = ({ onFilterChange }) => {
//   const { checkAccessTime, fetchAccessToken } = useService();
//   const [getAllCommonAdminInitialData] = useGetAllCommonAdminInitialDataMutation();
  
//   const [sectionsData, setSectionsData] = useState([]);
//   const [standardsData, setStandardsData] = useState([]);
//   const [subjectsData, setSubjectsData] = useState([]);
//   const [lessonsData, setLessonsData] = useState([]);

//   const [selectedSection, setSelectedSection] = useState(null);
//   const [selectedStandard, setSelectedStandard] = useState(null);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedLesson, setSelectedLesson] = useState(null);
  
//   const accessToken = fetchAccessToken();
//   const [loading, setLoading] = useState(false);
//   const [loadingStage, setLoadingStage] = useState('');

//   useEffect(() => {
//     loadSections();
//   }, []);

//   useEffect(() => {
//     if (selectedSection) {
//       loadStandards(selectedSection);
//       setSelectedStandard(null);
//       setSelectedSubject(null);
//       setSelectedLesson(null);
//       setSubjectsData([]);
//       setLessonsData([]);
//     }
//   }, [selectedSection]);

//   useEffect(() => {
//     if (selectedSection && selectedStandard) {
//       loadSubjects(selectedSection, selectedStandard);
//       setSelectedSubject(null);
//       setSelectedLesson(null);
//       setLessonsData([]);
//     }
//   }, [selectedStandard]);

//   useEffect(() => {
//     if (selectedSection && selectedStandard && selectedSubject) {
//       loadLessons(selectedSection, selectedStandard, selectedSubject);
//       setSelectedLesson(null);
//     }
//   }, [selectedSubject]);

//   useEffect(() => {
//     onFilterChange?.({
//       sectionId: selectedSection,
//       standardId: selectedStandard,
//       subjectId: selectedSubject,
//       lessonId: selectedLesson,
      
//     });
//   }, [selectedSection, selectedStandard, selectedSubject, selectedLesson]);

//   const loadSections = async () => {
//     setLoading(true);
//     setLoadingStage('sections');
//     try {
//       const response = await getAllCommonAdminInitialData({
//         ep: '/section/section_list',
//         token: accessToken,
//       });

//       if (response?.data?.data?.length > 0) {
//         setSectionsData(response.data.data);
//         setSelectedSection(response.data.data[0].id);
//       }
//     } catch (error) {
//       console.error('Error loading sections:', error);
//     }
//     setLoading(false);
//     setLoadingStage('');
//   };

//   const loadStandards = async (sectionId) => {
//     setLoading(true);
//     setLoadingStage('standards');
//     try {
//       const response = await getAllCommonAdminInitialData({
//         ep: `/standard/data?section_id=${sectionId}`,
//         token: accessToken,
//       });

//       if (response?.data?.data?.length > 0) {
//         const activeStandards = response.data.data.filter((item) => item.active === 'on');
//         setStandardsData(activeStandards);
//       }
//     } catch (error) {
//       console.error('Error loading standards:', error);
//     }
//     setLoading(false);
//     setLoadingStage('');
//   };

//   const loadSubjects = async (sectionId, standardId) => {
//     setLoading(true);
//     setLoadingStage('subjects');
//     try {
//       const response = await getAllCommonAdminInitialData({
//         ep: `/subject/data?section_id=${sectionId}&standard_id=${standardId}`,
//         token: accessToken,
//       });

//       if (response?.data?.data?.length > 0) {
//         const activeSubjects = response.data.data.filter((item) => item.active === 'on');
//         setSubjectsData(activeSubjects);
//       }
//     } catch (error) {
//       console.error('Error loading subjects:', error);
//     }
//     setLoading(false);
//     setLoadingStage('');
//   };

//   const loadLessons = async (sectionId, standardId, subjectId) => {
//     setLoading(true);
//     setLoadingStage('lessons');
//     try {
//       const response = await getAllCommonAdminInitialData({
//         ep: `/lesson/homework_lessons?section_id=${sectionId}&standard_id=${standardId}&subject_id=${subjectId}`,
//         token: accessToken,
//       });

//       if (response?.data?.data?.length > 0) {
//         const activeLessons = response.data.data.filter((item) => item.active === 'on');
//         setLessonsData(activeLessons);
//       }
//     } catch (error) {
//       console.error('Error loading lessons:', error);
//     }
//     setLoading(false);
//     setLoadingStage('');
//   };

//   const FilterTabSection = ({ icon, label, items, selectedId, onSelect, disabled, stage }) => (
//     <div className="filter-tab-section mb-3">
//       <div className="d-flex align-items-center justify-content-between mb-2">
//         <label className="form-label fw-semibold mb-0 d-flex align-items-center">
//           <i className={`bi ${icon} me-2 text-primary`}></i>
//           <span className="small">{label}</span>
//         </label>
//         <div className="d-flex align-items-center gap-2">
//           {loading && loadingStage === stage && (
//             <span className="spinner-border spinner-border-sm text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </span>
//           )}
//           {selectedId && !disabled && (
//             <button
//               className="btn btn-sm btn-link text-danger p-0"
//               onClick={() => onSelect(null)}
//               title={`Clear ${label}`}
//               type="button"
//             >
//               <i className="bi bi-x-circle-fill"></i>
//             </button>
//           )}
//         </div>
//       </div>
      
//       <div className="filter-tabs-wrapper">
//         {items.length === 0 && !loading ? (
//           <div className="text-muted small fst-italic">No {label.toLowerCase()} available</div>
//         ) : (
//           <div className="filter-tabs d-flex flex-wrap gap-2">
//             {items.map((item) => (
//               <button
//                 key={item.id}
//                 className={`btn btn-sm filter-tab ${selectedId === item.id ? 'active' : ''}`}
//                 onClick={() => !disabled && onSelect(item.id)}
//                 disabled={disabled}
//                 type="button"
//               >
//                 {item.name}
//                 {selectedId === item.id && (
//                   <i className="bi bi-check-circle-fill ms-2"></i>
//                 )}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   return (
//     <>
//       <link
//         rel="stylesheet"
//         href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
//       />
//       <link
//         rel="stylesheet"
//         href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css"
//       />

//       <div className="filter-container card shadow-sm border-0 mb-3">
//         <div className="card-header bg-gradient text-white py-2">
//           <div className="d-flex align-items-center">
//             <i className="bi bi-funnel-fill me-2"></i>
//             <h6 className="mb-0 fw-bold">Filter Options</h6>
//           </div>
//         </div>
//         <div className="card-body p-3">
//           <FilterTabSection
//             icon="bi-grid-3x3-gap-fill"
//             label="Section"
//             items={sectionsData}
//             selectedId={selectedSection}
//             onSelect={setSelectedSection}
//             disabled={false}
//             stage="sections"
//           />

//           <FilterTabSection
//             icon="bi-mortarboard-fill"
//             label="Standard"
//             items={standardsData}
//             selectedId={selectedStandard}
//             onSelect={setSelectedStandard}
//             disabled={!selectedSection}
//             stage="standards"
//           />

//           <FilterTabSection
//             icon="bi-book-fill"
//             label="Subject"
//             items={subjectsData}
//             selectedId={selectedSubject}
//             onSelect={setSelectedSubject}
//             disabled={!selectedStandard}
//             stage="subjects"
//           />

//           <FilterTabSection
//             icon="bi-journal-text"
//             label="Lesson"
//             items={lessonsData}
//             selectedId={selectedLesson}
//             onSelect={setSelectedLesson}
//             disabled={!selectedSubject}
//             stage="lessons"
//           />
//         </div>
//       </div>

//       <style>{`
//         .filter-container {
//           border-radius: 12px;
//           overflow: hidden;
//         }

//         .bg-gradient {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//         }

//         .filter-tab-section {
//           padding-bottom: 1rem;
//           border-bottom: 1px solid #e9ecef;
//         }

//         .filter-tab-section:last-child {
//           border-bottom: none;
//           padding-bottom: 0;
//           margin-bottom: 0 !important;
//         }

//         .filter-tabs-wrapper {
//           min-height: 36px;
//         }

//         .filter-tab {
//           border: 2px solid #e9ecef;
//           border-radius: 20px;
//           padding: 0.5rem 1.2rem;
//           background-color: #137dc1;
//           color: #495057;
//           font-weight: 500;
//           transition: all 0.3s ease;
//           display: inline-flex;
//           align-items: center;
//           font-size: 0.875rem;
//           white-space: nowrap;
//           line-height: 1.5;
//         }

//         .filter-tab:hover:not(:disabled) {
//           border-color: #667eea;
//           color: #667eea;
//           background-color: #050a0fff;
//           transform: translateY(-2px);
//           box-shadow: 0 4px 8px rgba(102, 126, 234, 0.2);
//         }

//         .filter-tab.active {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border-color: #667eea;
//           color: white !important;
//           box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
//           font-weight: 600;
//         }

//         .filter-tab:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }

//         .filter-tab i {
//           font-size: 0.875rem;
//         }

//         .text-primary {
//           color: #667eea !important;
//         }

//         .spinner-border-sm {
//           width: 0.875rem;
//           height: 0.875rem;
//           border-width: 0.15em;
//         }

//         .btn-link {
//           text-decoration: none;
//         }

//         .btn-link:hover {
//           opacity: 0.8;
//         }

//         @media (max-width: 576px) {
//           .filter-tab {
//             font-size: 0.813rem;
//             padding: 0.45rem 1rem;
//           }

//           .filter-tabs {
//             gap: 0.5rem !important;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default CommonTableFilters;

import React, { useState, useEffect } from 'react';
import { useGetAllCommonAdminInitialDataMutation } from 'slices/get/common';
import useService from 'views/default/useService';
import { useLocation } from 'react-router-dom';

const CommonTableFilters = ({ onFilterChange }) => {
  const { checkAccessTime, fetchAccessToken } = useService();
  const [getAllCommonAdminInitialData] = useGetAllCommonAdminInitialDataMutation();
  const location = useLocation();

  const [sectionsData, setSectionsData] = useState([]);
  const [standardsData, setStandardsData] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);
  const [lessonsData, setLessonsData] = useState([]);

  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedStandard, setSelectedStandard] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [selectedSeriesId, setSelectedSeriesId] = useState(null);
  const [totalLessons, setTotalLessons] = useState(null);
  const [totalPlans, setTotalPlans] = useState(null);

  const accessToken = fetchAccessToken();
  const [loading, setLoading] = useState(false);
  const [loadingStage, setLoadingStage] = useState('');

  // --- Load sections on mount ---
  useEffect(() => {
    loadSections();
  }, []);

  // --- When section changes ---
  useEffect(() => {
    if (selectedSection) {
      loadStandards(selectedSection);
      setSelectedStandard(null);
      setSelectedSubject(null);
      setSelectedLesson(null);
      setSubjectsData([]);
      setLessonsData([]);
      setSelectedSeriesId(null);
    }
  }, [selectedSection]);

  // --- When standard changes ---
  useEffect(() => {
    if (selectedSection && selectedStandard) {
      loadSubjects(selectedSection, selectedStandard);
      setSelectedSubject(null);
      setSelectedLesson(null);
      setLessonsData([]);
    }
  }, [selectedStandard]);

  // --- When subject changes ---
  useEffect(() => {
    if (selectedSection && selectedStandard && selectedSubject && selectedSeriesId ) {
      loadLessons(selectedSection, selectedStandard, selectedSubject,selectedSeriesId);
      loadLessonCounts(selectedSection, selectedStandard, selectedSubject, selectedSeriesId);
      setSelectedLesson(null);
    }
  }, [selectedSubject]);

  // --- Pass filter changes upward ---
  useEffect(() => {
    onFilterChange?.({
      sectionId: selectedSection,
      standardId: selectedStandard,
      subjectId: selectedSubject,
      lessonId: selectedLesson,
      seriesId: selectedSeriesId, // ✅ include series ID
      totalLessons,
      totalPlans,
    });
  }, [
    selectedSection,
    selectedStandard,
    selectedSubject,
    selectedLesson,
    selectedSeriesId,
    totalLessons,
    totalPlans,
  ]);

  // ==============================
  // LOAD FUNCTIONS
  // ==============================
  const loadSections = async () => {
    setLoading(true);
    setLoadingStage('sections');
    try {
      const response = await getAllCommonAdminInitialData({
        ep: '/section/section_list',
        token: accessToken,
      });
      if (response?.data?.data?.length > 0) {
        setSectionsData(response.data.data);
        setSelectedSection(response.data.data[0].id);
      }else{
        setSectionsData([])
      }
    } catch (error) {
      console.error('Error loading sections:', error);
    }
    setLoading(false);
    setLoadingStage('');
  };

  const loadStandards = async (sectionId) => {
    setLoading(true);
    setLoadingStage('standards');
    try {
      const response = await getAllCommonAdminInitialData({
        ep: `/standard/data?section_id=${sectionId}`,
        token: accessToken,
      });
      if (response?.data?.data?.length > 0) {
        const activeStandards = response.data.data.filter(
          (item) => item.active === 'on'
        );
        setStandardsData(activeStandards);
      }else{
        setStandardsData([])
      }
    } catch (error) {
      console.error('Error loading standards:', error);
    }
    setLoading(false);
    setLoadingStage('');
  };

  const loadSubjects = async (sectionId, standardId) => {
    setLoading(true);
    setLoadingStage('subjects');
    try {
      const response = await getAllCommonAdminInitialData({
        ep: `/subject/data?section_id=${sectionId}&standard_id=${standardId}`,
        token: accessToken,
      });
      if (response?.data?.data?.length > 0) {
        const activeSubjects = response.data.data.filter(
          (item) => item.active === 'on'
        );
        setSubjectsData(activeSubjects);
      }else{
        setSubjectsData([])
      }
    } catch (error) {
      console.error('Error loading subjects:', error);
    }
    setLoading(false);
    setLoadingStage('');
  };

  const loadLessons = async (sectionId, standardId, subjectId, selectedSeriesId) => {
    setLoading(true);
    setLoadingStage('lessons');
    try {
      const isDayPlanPage = location.pathname.startsWith('/day_plan');

      const endpoint = isDayPlanPage
        ? `/lesson/get_lessons_with_dayplan_count?section_id=${sectionId}&standard_id=${standardId}&subject_id=${subjectId}&series_ids=${selectedSeriesId}`
        : `/lesson/get_lessons?section_id=${sectionId}&standard_id=${standardId}&subject_id=${subjectId}&series_ids=${selectedSeriesId}`;

      const response = await getAllCommonAdminInitialData({
        ep: endpoint,
        token: accessToken,
      });
      if (response?.data?.data?.length > 0) {
        const activeLessons = response.data.data
          .filter((item) => item.active === 'on')
          .map((each) => {
            const teacherPlan = each.total_plans ?? each.total_plans;
            const name =
              isDayPlanPage && teacherPlan != null
                ? `${each.lesson} (${teacherPlan})`
                : each.lesson;
            return { id: each.id, name };
          });

        setLessonsData(activeLessons);
      }else{
        setLessonsData([])
      }
    } catch (error) {
      console.error('Error loading lessons:', error);
    }
    setLoading(false);
    setLoadingStage('');
  };

  const loadLessonCounts = async (sectionId, standardId, subjectId, selectedSeriesId) => {
    try {
      const response = await getAllCommonAdminInitialData({
        ep: `/lesson/get_lessons_count_with_dayplan_count?section_id=${sectionId}&standard_id=${standardId}&subject_id=${subjectId}&series_ids=${selectedSeriesId}`,
        token: accessToken,
      });

      if (response?.data?.data?.length > 0) {
        const stats = response.data.data[0] || {};
        setTotalLessons(stats.total_lessons ?? 0);
        setTotalPlans(stats.total_plans ?? 0);
      } else {
        setTotalLessons(0);
        setTotalPlans(0);
      }
    } catch (error) {
      console.error('Error loading lesson counts:', error);
      setTotalLessons(0);
      setTotalPlans(0);
    }
  };

  // ==============================
  // FILTER TAB COMPONENT
  // ==============================
  const FilterTabSection = ({
    icon,
    label,
    items,
    selectedId,
    onSelect,
    disabled,
    stage,
  }) => (
    <div className="filter-tab-section mb-3">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <label className="form-label fw-semibold mb-0 d-flex align-items-center">
          <i className={`bi ${icon} me-2 text-primary`}></i>
          <span className="small">{label}</span>
        </label>
        <div className="d-flex align-items-center gap-2">
          {loading && loadingStage === stage && (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </span>
          )}
          {selectedId && !disabled && (
            <button
              className="btn btn-sm btn-link text-danger p-0"
              onClick={() => onSelect(null)}
              title={`Clear ${label}`}
              type="button"
            >
              <i className="bi bi-x-circle-fill"></i>
            </button>
          )}
        </div>
      </div>

      <div className="filter-tabs-wrapper">
        {items.length === 0 && !loading ? (
          <div className="text-muted small fst-italic">
            No {label.toLowerCase()} available
          </div>
        ) : (
          <div className="filter-tabs d-flex flex-wrap gap-2">
            {items.map((item) => (
              <button
                key={item.id}
                className={`btn btn-sm filter-tab ${
                  selectedId === item.id ? 'active' : ''
                }`}
                onClick={() => !disabled && onSelect(item.id)}
                disabled={disabled}
                type="button"
              >
                {item.name}
                {selectedId === item.id && (
                  <i className="bi bi-check-circle-fill ms-2"></i>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  // ==============================
  // RETURN UI
  // ==============================
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
      />
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css"
      />

      <div className="filter-container card shadow-sm border-0 mb-3">
        <div className="card-header bg-gradient text-white py-2">
          <div className="d-flex align-items-center">
            <i className="bi bi-funnel-fill me-2"></i>
            <h6 className="mb-0 fw-bold">Filter Options</h6>
          </div>
        </div>
        <div className="card-body p-3">
          {/* SECTION */}
          <FilterTabSection
            icon="bi-grid-3x3-gap-fill"
            label="Section"
            items={sectionsData}
            selectedId={selectedSection}
            onSelect={setSelectedSection}
            disabled={false}
            stage="sections"
          />

          {/* STANDARD */}
          <FilterTabSection
            icon="bi-mortarboard-fill"
            label="Standard"
            items={standardsData}
            selectedId={selectedStandard}
            onSelect={(id) => {
              const selectedStd = standardsData.find((s) => s.id === id);
              setSelectedStandard(id);
              setSelectedSeriesId(selectedStd?.series_id || null); // ✅ Save series_id
            }}
            disabled={!selectedSection}
            stage="standards"
          />

          {/* SUBJECT */}
          <FilterTabSection
            icon="bi-book-fill"
            label="Subject"
            items={subjectsData}
            selectedId={selectedSubject}
            onSelect={setSelectedSubject}
            disabled={!selectedStandard}
            stage="subjects"
          />

          {/* LESSON */}
          <FilterTabSection
            icon="bi-journal-text"
            label="Lesson"
            items={lessonsData}
            selectedId={selectedLesson}
            onSelect={setSelectedLesson}
            disabled={!selectedSubject}
            stage="lessons"
          />
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .filter-container {
          border-radius: 5px;
          overflow: hidden;
        }
        .bg-gradient {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }
        .filter-tab-section {
          padding-bottom: 1rem;
          border-bottom: 1px solid #e9ecef;
        }
        .filter-tab-section:last-child {
          border-bottom: none;
          padding-bottom: 0;
          margin-bottom: 0 !important;
        }
        .filter-tabs-wrapper {
          min-height: 36px;
        }
        .filter-tab {
          border: 2px solid #e9ecef;
          border-radius: 5px;
          padding: 0.5rem 1.2rem;
          background-color: #137dc1;
          color: #fff;
          font-weight: 500;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          font-size: 0.875rem;
          white-space: nowrap;
          line-height: 1.5;
        }
        .filter-tab:hover:not(:disabled) {
          border-color: #667eea;
          background-color: #050a0f;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(102, 126, 234, 0.2);
        }
        .filter-tab.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-color: #667eea;
          color: white !important;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
          font-weight: 600;
        }
        .filter-tab:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .spinner-border-sm {
          width: 0.875rem;
          height: 0.875rem;
          border-width: 0.15em;
        }
        .btn-link {
          text-decoration: none;
        }
        .btn-link:hover {
          opacity: 0.8;
        }
        @media (max-width: 576px) {
          .filter-tab {
            font-size: 0.813rem;
            padding: 0.45rem 1rem;
          }
          .filter-tabs {
            gap: 0.5rem !important;
          }
        }
      `}</style>
    </>
  );
};

export default CommonTableFilters;
